import React from "react"
import { ReferenceField, ReferenceFieldProps, TextField } from "react-admin"

export const BillStatusRefField: React.FC<Partial<ReferenceFieldProps>> = (props) => (
  <ReferenceField
    {...props}
    source="bill_status_id"
    reference="bill_statuses"
    link="show"
    label="Status"
  >
    <TextField source="status" />
  </ReferenceField>
)
